import { render, staticRenderFns } from "./form_waku.vue?vue&type=template&id=3e997724&"
import script from "./form_waku.vue?vue&type=script&lang=js&"
export * from "./form_waku.vue?vue&type=script&lang=js&"
import style0 from "./form_waku.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports